// extracted by mini-css-extract-plugin
export var actionButton = "_qy-0";
export var actionMenuContainer = "_qy-i";
export var bubble = "_qy-2";
export var bubbleActionMenu = "_qy-j";
export var bubbleContext = "_qy-6";
export var bubbleItems = "_qy-7";
export var customer = "_qy-3";
export var divider = "_qy-8";
export var fileList = "_qy-9";
export var hiddenComment = "_qy-o";
export var infoAbove = "_qy-a";
export var internal = "_qy-4";
export var lightActionButton = "_qy-1";
export var link = "_qy-b";
export var merchant = "_qy-5";
export var message = "_qy-c";
export var profilePicture = "_qy-e";
export var quillToolbarContainer = "_qy-f";
export var senderDate = "_qy-g";
export var senderDateCustomer = "_qy-h";
export var senderName = "_qy-d";
export var time = "_qy-k";
export var uploadedImage = "_qy-l";
export var username = "_qy-m";
export var xsmall = "_qy-n";